export default __webpack_public_path__ + "static/media/17.60366437.jpg";